import { AsideMenu } from '@/views/UserCenter/AsideMenu'
import type { CustomDefineComponent } from './types'

type UserCenterConfig = {
  /** 侧边栏菜单 */
  AsideMenu: CustomDefineComponent | null
}

type PlatformName = ImportMetaEnv['VITE_PLATFORM']

type ConfigMap = Partial<Record<PlatformName, Partial<UserCenterConfig>>>

const platform = import.meta.env.VITE_PLATFORM

const CRYPTO_CONFIG: UserCenterConfig = {
  AsideMenu: AsideMenu,
}

const NOT_CRYPTO_CONFIG: UserCenterConfig = {
  AsideMenu: null,
}

const HASH_SPACE_CONFIG: UserCenterConfig = NOT_CRYPTO_CONFIG

const BGE_CONFIG: UserCenterConfig = NOT_CRYPTO_CONFIG

const CONFIG_MAP: ConfigMap = {
  topcredit: CRYPTO_CONFIG,
  '8v': CRYPTO_CONFIG,
  e97: CRYPTO_CONFIG,
  hashspace: HASH_SPACE_CONFIG,
  bge: BGE_CONFIG,
  b9: CRYPTO_CONFIG,
}

export const USER_CENTER_CONFIG = CONFIG_MAP[platform] || CRYPTO_CONFIG
